<style>
.helpline a {
    text-decoration: none;     /* Remove underline */
    color: inherit;            /* Keep parent text color */
}

.helpline a:hover {
    color: inherit;            /* Prevent hover color change */
}
@media (max-width: 575px) {
    .first-row {
        padding: 4px 0 !important;
        font-size: 12px !important;
    }

    .first-row .helpline span {
        font-size: 12px !important;
    }

}

</style>
<template>
      <Toast ref="toast" />
      <!-- Top Bar start-->
      <header>
            <!-- Row 1: 6 text menus centered -->
            <div class="hdr-first-row">
              <div class="container first-row d-flex justify-content-between p16-0">
                  <div class="helpline lh16">
                      <!-- @click="callNow" -->
                      <a href="tel:4712941101" target="_self" rel="nofollow" class="d-flex align-items-center" style="cursor:pointer;">
                          <svg xmlns="http://www.w3.org/2000/svg" 
                                width="17" height="17" 
                                fill="none" 
                                stroke="currentColor" 
                                stroke-width="1.8" 
                                stroke-linecap="round" 
                                stroke-linejoin="round" 
                                viewBox="0 0 24 24" 
                                class="me-2">
                              <path d="M22 16.92v3a2 2 0 0 1-2.18 2
                                      19.79 19.79 0 0 1-8.63-3.07
                                      19.5 19.5 0 0 1-6-6
                                      19.79 19.79 0 0 1-3.07-8.67
                                      A2 2 0 0 1 4.08 2h3a2 2 0 0 1 2 1.72
                                      c.12.81.37 1.6.72 2.34a2 2 0 0 1-.45 2.18L8.09 9.91a16 16 0 0 0 6 6l1.67-1.26
                                      a2 2 0 0 1 2.18-.45c.74.35 1.53.6 2.34.72A2 2 0 0 1 22 16.92z"/>
                          </svg>
                          <span>24/7 Helpline: <span class="color-purple">471 294 1101</span></span>
                      </a>
                  </div>

                  <div class="whatsapp-logo">
                      <a href="https://wa.me/919072881666" target="_blank" class="d-flex align-items-center">
                          <img src="@/assets/Images_new/whatsapp.png" class="img-fluid" alt="KIMS HEALTH - LOGO">
                          <span class="ms-1"></span>
                      </a>
                  </div>
              </div>
            </div>

            <!-- Row 2 -->
            <div class=" container second-row d-flex justify-content-between ">
                <!--logo-->
                <div><a :href="homePage"><img src="@/assets/Images_new/KIMS LOGO.png" class="img-fluid" alt="KIMS HEALTH - LOGO"></a></div>
                <!--Nav Section-->
                <div class="nav-section">
                    <nav class="navbar navbar-expand-lg p0 m-navbar-expand">
                        <div class="container-fluid main-top-nav p0">
                            <button class="navbar-toggler" type="button" @click="toggleNav" aria-label="Toggle navigation">
                              <span class="navbar-toggler-icon"></span>
                            </button>

    
                            <div class="collapse navbar-collapse" id="mainNav" ref="mainNavRef">
                              <div class="collapsing-cont">
                                <div class="m-menu-links">
                                    <ul class="navbar-nav mb-2 mb-lg-0 main-top-nav-ul">
                                        <li class="nav-item" :class="{ active: activeMenu === 'home' }"><a class="nav-link home "  @click="setActive('home')" href="/">Home</a></li>
                                        <li class="nav-item" :class="{ active: activeMenu === 'about' }"><a class="nav-link about"  @click="setActive('about')" target="_blank" href="https://www.kimshealth.org/about-us">About us</a></li>
                                        <!-- callSupportNow(); -->
                                        <li class="nav-item" :class="{ active: activeMenu === 'support' }"><a class="nav-link support" target="_self" rel="nofollow"  @click="setActive('support');" href="tel:+914712941101" >Support</a></li>
                                        <li class="nav-item" :class="{ active: activeMenu === 'contact' }"><a class="nav-link contact"  @click="setActive('contact')" target="_blank" href="https://www.kimshealth.org/contact-us">Contact Us</a></li>
                                        
                                    </ul>
                                </div>
                           
                                <!-- <div class="agent-profile "> Agent <i class="bi bi-caret-down-fill "></i></div> -->

                                <div class="d-flex">
                                    <div class="dropdown me-1">
                                      <div type="button" class="btn btn-secondary dropdown-toggle agent-profile" id="dropdownMenuOffset" data-bs-toggle="dropdown" aria-expanded="false" data-bs-offset="10,20">
                                        Agent
                                      </div>
                                      <ul class="dropdown-menu agent-show" aria-labelledby="dropdownMenuOffset">
                                        <li><a class="dropdown-item" v-if="!isAgentLoggedIn"  href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#agentSignInModal">Sign In</a></li>
                                        <li><a class="dropdown-item" v-if="!isAgentLoggedIn" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#agentRegistrationModal">Register</a></li>
                                        <li><a class="dropdown-item" v-if="isAgentLoggedIn" style="cursor: pointer; white-space: normal; word-break: break-word;" @click="goToProfile">👋 Hello, {{ agentName }}</a></li>
                                        <li><a class="dropdown-item" v-if="isAgentLoggedIn" style="text-align:center; cursor: pointer;" @click="logout">Logout</a></li>
                                      </ul>
                                    </div>
                                </div>
                             
                                <div class="m-agent-cont">
                                    <div class="agent-title">Agent</div>
                                    <div class="agent-link link1" v-if="!isAgentLoggedIn"  href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#agentSignInModal">Sign In</div>
                                    <div class="agent-link link1" v-if="!isAgentLoggedIn" href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#agentRegistrationModal">Register</div>
                                    <div class="agent-link link1" v-if="isAgentLoggedIn" style="cursor: pointer; white-space: normal; word-break: break-word;" @click="goToProfile">👋 Hello, {{ agentName }}</div>
                                    <div class="agent-link link1" v-if="isAgentLoggedIn" style="cursor: pointer;" @click="logout">&emsp;&nbsp;&nbsp;Logout</div>
                                </div>

                                <div>
                                    <a :href="trackAppointment" class="btn ms-lg-3 fw-semibold btn-track-appointment d-flex">
                                        
                                        <i class=" color-green icon-track-appointment"></i>
                                        <span class="btn-track-appoint-txt">Track Appointment</span>
        
                                    </a>
                                </div>

                                
                              </div>
                            </div>
                        </div>
                    </nav>

                </div>
                <!--Agent profile-->
               

            </div>


            <!-- Header Third Row -->
            <!-- <div class="hdr-breadcrumb-row border-top">
              <div class="breadcrumb-section">
                <div class="container text-center border-top hdr-row3">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                          <li class="breadcrumb-item"><a href="#">Home</a></li>
                          <li class="breadcrumb-item active" aria-current="page">Library</li>
                        </ol>
                    </nav>
                </div>
              </div>
            </div> -->


      </header>
      <!-- Top Bar End-->

      <!-- Main Navigation -->


      <!-- Hospital Profile Modal -->
      <div class="modal fade" id="profileModal" tabindex="-1" aria-hidden="true">
        <div :class="modalDialogClass">
          <div class="modal-content border-0 shadow-lg rounded-4 overflow-hidden">
            
            <!-- Header -->
            <div class="modal-header py-3 px-4 text-white"
                style="background: linear-gradient(135deg, #d32f2f, #b71c1c);">
              <div class="d-flex align-items-center">
                <img src="@/assets/Images/Logo/Footer Logo.png" alt="Hospital Logo"
                    style="height: 35px; margin-right: 12px;">
                <!-- <h5 class="modal-title fw-bold mb-0">Agent Profile</h5> -->
              </div>
              <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>

            <!-- Body -->
            <div class="modal-body p-4" v-if="agentStore.agentDetails" style="word-break: break-word; overflow-wrap: anywhere;">
              <div class="row">
                <!-- Personal Details -->
                <div class="col-md-6 mb-3">
                  <div class="p-3 border rounded-3 bg-light h-100">
                    <h6 class="fw-bold text-danger mb-3">Personal Information</h6>
                    <p class="mb-2"><strong>Name:</strong> {{ agentStore.agentDetails.user.name }}</p>
                    <p class="mb-2"><strong>Email:</strong> {{ agentStore.agentDetails.user.email }}</p>
                    <p class="mb-0"><strong>Contact:</strong> {{ agentStore.agentDetails.user.contact_no }}</p>
                  </div>
                </div>

                <!-- Agency Details -->
                <div class="col-md-6 mb-3">
                  <div class="p-3 border rounded-3 bg-light h-100">
                    <h6 class="fw-bold text-danger mb-3">Agency Details</h6>
                    <p class="mb-2"><strong>Agency Name:</strong> {{ agentStore.agentDetails.user.agent.agency_name }}</p>
                    <!-- <p class="mb-2"><strong>Aadhaar:</strong> {{ agentStore.agentDetails.user.agent.aadhaar }}</p> -->
                    <p class="mb-0">
                      <strong>Status:</strong>&emsp13;&emsp14;
                      <span :class="agentStore.agentDetails.user.agent.is_verified ? 'text-success fw-semibold' : 'text-warning fw-semibold'">
                        {{ agentStore.agentDetails.user.agent.is_verified ? 'Verified' : 'Not Verified' }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>

              <!-- Divider -->
              <hr class="my-3">

              <!-- Hospital Footer Info (Optional) -->
              <div class="text-center small text-muted">
                <p class="mb-0">KIMS Health — Secure Agent Access Portal</p>
              </div>
            </div>

            <!-- Footer -->
            <div class="modal-footer d-flex justify-content-between align-items-center py-3"
                style="background: linear-gradient(135deg, #d32f2f, #b71c1c);">
                <!-- Change Password Button -->
                <span class="text-white fw-semibold"
                      style="cursor: pointer; text-decoration: underline;"
                      @click="openChangePasswordModal">
                  Are you sure? Reset your login password
                </span>

              <button type="button" class="btn btn-light px-4" data-bs-dismiss="modal">Close</button>
            </div>

          </div>
        </div>
      </div>


      <!-- First Modal: Email Confirmation -->
      <div class="modal fade" id="emailAgentModal" tabindex="-1" aria-labelledby="emailAgentModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content py-3">

            <!-- Close button -->
            <button type="button" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal" aria-label="Close"></button>
            
            <div class="modal-header px-5 border-0 justify-content-center">
              <h5 class="modal-title">
                <img src="@/assets/Images/Logo/kims-logo.png" width="250">
              </h5>
            </div>

            <div class="modal-body px-lg-5 text-center">
              <p class="mb-4 text-start">Please confirm your Email address</p>

              <div class="mb-3 text-start">
                <input type="email"
                      v-model="reemail"
                      class="form-control mb-3 custom-placeholder"
                      readonly>
              </div>

              <a class="btn btn-danger w-100" :disabled="loading" @click="validationMain">
                <span v-if="loading"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
                <span v-else>Confirm</span>
              </a>
            </div>

          </div>
        </div>
      </div>


      <!-- otp verification -->
      <div class="modal fade" id="otpModal" tabindex="-1" aria-labelledby="otpModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content p-4 rounded-4">

                  <!-- Close button -->
                  <button type="button" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal" aria-label="Close"></button>

                  <div class="modal-header px-5 border-0 justify-content-center">
                    <h5 class="modal-title"><img src="@/assets/Images/Logo/kims-logo.png" width="250"></h5>
                  </div>



                  <div class="modal-body">
                      <!-- <img src="@/assets/Images/Logo/kims-logo.png" alt="KIMSHEALTH" class="mb-3" style="max-width:260px;"> -->
                      <p class="otp_text mb-4">Please enter the OTP received on your email address</p>
          
                      <div class="d-flex justify-content-center mb-3 gap-1 otp-input-group flex-wrap justify-content-between">
                      <input
                          v-for="(digit, index) in otp"
                          :key="index"
                          type="text"
                          class="form-control otp-box text-center"
                          maxlength="1"
                          v-model="otp[index]"
                          @input="focusNext(index, $event)"
                          @keydown.backspace="focusPrev(index, $event)"
                          ref="otpInputs"
                      />
                      </div>
          
                      <small v-if="errors.otpError" class="text-danger">{{ errors.otpError }}</small>
          
                      <a class="btn btn-danger w-100" @click="validationOTPMain(registeredEmail)" :disabled="loading || otpIncomplete">
                        <span v-if="!loading && !resendloading">Confirm</span>
                        <span v-else-if="resendloading">
                          <i class="fa fa-spinner fa-spin"></i> Resending...
                        </span>
                        <span v-else>
                          <i class="fa fa-spinner fa-spin"></i> Processing...
                        </span>
                      </a>
          
                      <div class="d-flex justify-content-between mt-3">
                          <span class="resend">Resend OTP in <span class="timer">{{ formattedTime }}</span></span>
                          <a href="#" 
                            class="resend_btn text-decoration-none" 
                            @click.prevent="handleResend(registeredEmail)" 
                            :class="{'text-muted': timer > 0 || resendloading, 'text-danger': timer === 0 && !resendloading}" 
                            :style="(timer > 0 || resendloading) ? 'pointer-events: none;' : 'pointer-events: auto;'">
                            <span v-if="!resendloading">Resend</span>
                            <span v-else>
                                <i class="fa fa-spinner fa-spin"></i> Resending...
                            </span>
                          </a>

                      </div>
                  </div>

            </div>
          </div>
      </div>


      <!-- Change Password Modal -->
      <div class="modal fade" id="changePasswordModal" tabindex="-1" aria-labelledby="changePasswordModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content py-3">

            <!-- Close button -->
            <button type="button" class="btn-close position-absolute top-0 end-0 m-3" data-bs-dismiss="modal" aria-label="Close"></button>

            <div class="modal-header px-5 border-0 justify-content-center">
              <h5 class="modal-title"><img src="@/assets/Images/Logo/kims-logo.png" width="250"></h5>
            </div>

            <div class="modal-body px-lg-5 text-center">
              <p class="mb-4 text-start">Please enter your new password</p>

              <div class="mb-3 text-start">
                <input type="password"
                      v-model="newPassword"
                      class="form-control mb-3 custom-placeholder"
                      placeholder="New Password">
              </div>

              <div class="mb-3 text-start">
                <input type="password"
                      v-model="confirmPassword"
                      class="form-control mb-3 custom-placeholder"
                      placeholder="Confirm Password">
                      <small v-if="errors.passwordError && !confirmPasswordError" class="text-danger">
                        {{ errors.passwordError }}
                      </small>
              </div>

              <a class="btn btn-danger w-100" :disabled="loadingChangePassword" @click="updatePassword(registeredEmail)">
                <span v-if="loadingChangePassword"><i class="fa fa-spinner fa-spin"></i> Processing...</span>
                <span v-else>Update Password</span>
              </a>

            </div>

          </div>
        </div>
      </div>



  
</template>



<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useAgentStore } from '@/store/agent';
import { useRoute } from 'vue-router';
import { AgentLogout, AgentOTPResend, AgentVerifyOTP, AgentUpdatePassword } from '@/api/Agent/sign';
import Toast from '@/components/Toast/agentToast.vue';
// main.js
import 'bootstrap';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // includes Popper and Collapse


const agentStore = useAgentStore();
const route = useRoute(); 
const dropdownOpen = ref(false);

const trackAppointment = ref('/trackAppointment');
const isAgentLoggedIn  = ref(false);
let bsCollapse = null;
const mainNavRef = ref(null);
const activeMenu = ref("home");

const homePage = ref('/');


const toggleNav = () => {
  // if instance exists, toggle it; otherwise fallback to class toggle
  if (bsCollapse) {
    bsCollapse.toggle();
  } else if (mainNavRef.value) {
    mainNavRef.value.classList.toggle('show');
  }
};
// Refs
const userBadge = ref(null);
const toast = ref(null); // <-- Toast ref
const modalDialogClass = ref('modal-dialog modal-dialog-centered modal-lg');

onMounted(() => {
  agentStore.loadAgentDetails();
  updateModalClass();
  window.addEventListener('resize', updateModalClass);
  checkAgentLogin();
  setActive();
  // initialize bootstrap Collapse instance and do not auto-toggle
  if (mainNavRef.value && window.bootstrap && window.bootstrap.Collapse) {
    bsCollapse = new window.bootstrap.Collapse(mainNavRef.value, { toggle: false });

    // optional: debug listeners
    mainNavRef.value.addEventListener('shown.bs.collapse', () => {
      // runs when opened
      // console.log('mainNav shown');
    });
    mainNavRef.value.addEventListener('hidden.bs.collapse', () => {
      // runs when hidden
      // console.log('mainNav hidden');
    });
  } else {
    // fallback debug: bootstrap missing
    // console.warn('Bootstrap collapse not initialised. Make sure bootstrap.bundle is loaded.');
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', updateModalClass);
  if (bsCollapse) {
    try { bsCollapse.dispose(); } catch(e) {}
    bsCollapse = null;
  }
});

const agentName = computed(() => {
  const data = agentStore.agentDetails;
  return data?.user?.name  || '';
});

const agentEmail = computed(() => {
  const data = agentStore.agentDetails;
  return data?.user?.email  || '';
});

const formattedTime = computed(() => {
  const minutes = Math.floor(timer.value / 60);
  const seconds = timer.value % 60;
  return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
});

const otpIncomplete = computed(() => otp.value.some(d => !d));

const updateModalClass = () => {
  if (window.innerWidth <= 768) {
    // Mobile
    modalDialogClass.value = 'modal-dialog modal-dialog-centered modal-lg';
  } else {
    // Desktop
    modalDialogClass.value = 'modal-dialog modal-dialog-centered modal-lg';
  }
};
const checkAgentLogin = () => {
  agentStore.loadAgentDetails(); 
  if (agentStore.agentDetails) {
    isAgentLoggedIn.value = true;             // use .value
    // optional: store name in a ref if needed
    // agentName.value = agentStore.agentDetails?.user?.name || 'Agent';
  } else {
    isAgentLoggedIn.value = false;
    // agentName.value = '';
  }
};

const setActive = (menu) => {
  const path = route.path;  // now works correctly

  if (path === '/privacy-policy') {
    activeMenu.value = 'privacy';
  } else if (path === '/terms-conditions') {
    activeMenu.value = 'terms';
  } else {

    if (menu) {
      activeMenu.value = menu;
      return;
    }
    activeMenu.value = 'home';
  }
};

const callNow = () => {
    const isMobile = /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);

    if (isMobile) {
      // Mobile → call normally
      window.location.href = "tel:+914712941101";
    } else {
      // Desktop → prevent WhatsApp
      alert("Please call this number from your mobile phone:\n+91 471 294 1101");
    }
};
const callSupportNow = () => {
    const isMobile = /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);

    if (isMobile) {
      // Mobile → call normally
      window.location.href = "tel:+914712941400";
    } else {
      // Desktop → prevent WhatsApp
      alert("Please call this number from your mobile phone:\n+91 471 294 1400");
    }
};

const loading = ref(false);
const resendloading = ref(false);
const errors = ref({ reemail: '', otpError: '', passwordError: '' });
const reemail = ref('');
const otp = ref(Array(5).fill('')); // adjust length if needed
const registeredEmail = ref(''); // store confirmed email for OTP modal
const timer = ref(180); // total seconds, e.g., 3 minutes = 180s
let timerInterval = null;
const newPassword = ref('');
const confirmPassword = ref('');
const loadingChangePassword = ref(false);


// the change password section
function openChangePasswordModal() {
  reemail.value = agentStore.agentDetails?.user?.email || '';
  //  Profile Modal
  const profileModalEl = document.getElementById('profileModal');
  const profileModal = bootstrap.Modal.getInstance(profileModalEl);
  if (profileModal) {
    profileModal.hide();
  }
  //  email modal
  const emailAgentModalEl = document.getElementById('emailAgentModal');
  const emailAgentModal = new bootstrap.Modal(emailAgentModalEl);
  emailAgentModal.show();
}

async function validationMain() {
  // Reset errors
  errors.value.reemail = '';

  // Simple validation
  if (!reemail.value) {
    errors.value.reemail = 'Email is required';
    return;
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(reemail.value)) {
    errors.value.reemail = 'Invalid email address';
    return;
  }

  try {
    loading.value = true;

    // Call API to resend OTP
    const sendOTP = await AgentOTPResend(reemail.value);

    if (sendOTP?.data?.success) {
      // Store email for OTP modal
      registeredEmail.value = reemail.value;

      // Show success toast
      toast.value?.showToast('OTP sent successfully!', 'success', 1000);

      // Close email modal
      const emailAgentModalEl = document.getElementById('emailAgentModal');
      const emailAgentModal = bootstrap.Modal.getInstance(emailAgentModalEl);
      if (emailAgentModal) emailAgentModal.hide();

      // Open OTP modal
      const otpModalEl = document.getElementById('otpModal');
      const otpModal = new bootstrap.Modal(otpModalEl);
      otpModal.show();

      // Reset OTP inputs
      otp.value = Array(otp.value.length).fill('');

      startTimer();
    } else {
      errors.value.reemail = sendOTP?.data?.message || 'Failed to send OTP';
    }

  } catch (err) {
    console.error(err);
    errors.value.reemail = 'Something went wrong. Please try again.';
  } finally {
    loading.value = false;
  }
}

function focusNext(index, event) {
  const inputs = document.querySelectorAll('.otp-box');
  if (event.inputType === 'deleteContentBackward') return;
  if (index < inputs.length - 1 && event.target.value) {
    inputs[index + 1].focus();
  }
}

function focusPrev(index, event) {
  const inputs = document.querySelectorAll('.otp-box');
  if (event.key === 'Backspace' && index > 0 && !event.target.value) {
    inputs[index - 1].focus();
  }
}

function startTimer() {
  if (timerInterval) clearInterval(timerInterval);
  timer.value = 180; // 3 minutes

  timerInterval = setInterval(() => {
    if (timer.value > 0) {
      timer.value -= 1;
    } else {
      clearInterval(timerInterval);
    }
  }, 1000);
}

async function handleResend(email) {
  if (timer.value > 0 || resendloading.value) return; // prevent multiple clicks

  resendloading.value = true;
  otp.value = Array(otp.value.length).fill(''); // reset OTP inputs

  try {
    const response = await AgentOTPResend(email);

    if (response?.data?.success) {
      toast.value?.showToast('OTP resent successfully!', 'success', 1000);
      startTimer(); // restart countdown
    } else {
      toast.value?.showToast(response?.data?.message || 'Failed to resend OTP', 'error');
    }
  } catch (err) {
    console.error(err);
    toast.value?.showToast('Something went wrong. Please try again.', 'error');
  } finally {
    resendloading.value = false;
  }
}

async function validationOTPMain(responseEmail) {
  // Reset error
  errors.value.otpError = '';

  // Combine OTP array into string
  const enteredOtp = otp.value.join('');

  if (!enteredOtp || enteredOtp.length !== otp.value.length) {
    errors.value.otpError = 'Please enter the complete OTP.';
    return;
  }

  try {
    loading.value = true;

    // Call API
    const res = await AgentVerifyOTP(responseEmail, enteredOtp);

    //console.log('OTP Verified:', res);

    if (!res.data.success) {
      errors.value.otpError = res.data.message || 'Invalid or expired OTP.';
      return;
    }

    // OTP verified successfully
    //toast.value?.showToast('OTP verified successfully!', 'success', 1000);

    // Close OTP modal
    const otpModalEl = document.getElementById('otpModal');
    const otpModal = bootstrap.Modal.getInstance(otpModalEl);
    if (otpModal) otpModal.hide();

    // Open Change Password Modal
    const changePasswordModalEl = document.getElementById('changePasswordModal');
    const changePasswordModal = new bootstrap.Modal(changePasswordModalEl);
    changePasswordModal.show();

    // Optional: proceed to reset password modal
    // openResetPasswordModal();

  } catch (err) {
    console.error(err);
    errors.value.otpError = 'Something went wrong. Please try again.';
  } finally {
    loading.value = false;
  }
}

// Update password function
async function updatePassword(registeredEmail) {
  errors.value.passwordError = '';

  if (!newPassword.value || !confirmPassword.value) {
    errors.value.passwordError = 'Please fill both fields.';
    return;
  }

  if (newPassword.value !== confirmPassword.value) {
    errors.value.passwordError = 'Passwords do not match.';
    return;
  }

  try {
    loadingChangePassword.value = true;

    const res = await AgentUpdatePassword(registeredEmail, newPassword.value, confirmPassword.value);

    if (!res.data.success) {
      errors.value.passwordError = res.data.message || 'Failed to update password.';
      return;
    }

    toast.value?.showToast('Password updated successfully!', 'success', 1000);

    // Close Change Password Modal
    const changePasswordModalEl = document.getElementById('changePasswordModal');
    const changePasswordModal = bootstrap.Modal.getInstance(changePasswordModalEl);
    if (changePasswordModal) changePasswordModal.hide();

    //After success, logout automatically
    try {
      const logoutRes = await AgentLogout();
    } catch (error) {
      console.error(error);
    } finally {
      
      agentStore.clearAgentDetails();
      setTimeout(() => {
        window.location.reload();
      }, 1500); 
    }


    // Optional: redirect to login page
    // router.push('/login');

  } catch (err) {
    console.error(err);
    errors.value.passwordError = 'Something went wrong. Please try again.';
  } finally {
    loadingChangePassword.value = false;
  }
}




function toggleDropdown() {
  dropdownOpen.value = !dropdownOpen.value;
}

function goToProfile() {
  dropdownOpen.value = false;
  // Open Bootstrap modal instead of navigating
  const modalEl = document.getElementById('profileModal');
  const modal = new bootstrap.Modal(modalEl);
  modal.show();
}

async function logout() {
  dropdownOpen.value = false;

  try {
    const res = await AgentLogout();

    if (res.data && res.data.success) {
      toast.value?.showToast('Logout successful!', 'success', 1000); // 1 second
    } else {
      toast.value?.showToast(res.data.message || 'Logout failed!', 'error', 1000); // 1 second
    }
  } catch (error) {
    if (error.response) {
      toast.value?.showToast(error.response.data.message || `Error: ${error.response.status}`, 'error', 1000); // 1 second
    } else {
      toast.value?.showToast('Network or server error!', 'error', 1000); // 1 second
    }
  } finally {
    agentStore.clearAgentDetails();

    // Delay redirect slightly so toast is visible
    setTimeout(() => {
      window.location.reload();
    }, 1200); // slightly longer than toast duration
  }
}

// Close dropdown on outside click
function handleClickOutside(event) {
  if (userBadge.value && !userBadge.value.contains(event.target)) {
    dropdownOpen.value = false;
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped>



.user-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  position: relative;
  font-family: 'Segoe UI', sans-serif;
}

/* Badge */
.user-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-weight: 600;
  color: #b71c1c;
  transition: color 0.2s;
}

.user-badge:hover {
  color: #f44336;
}

/* User Info */
.user-info {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.user-name {
  font-size: 14px;
}

.user-email {
  font-size: 12px;
  color: #7f1d1d;
}

/* Arrow */
.arrow-down {
  transform: rotate(0deg);
  transition: transform 0.3s;
}

.arrow-up {
  transform: rotate(180deg);
  transition: transform 0.3s;
}

/* Dropdown */
.user-dropdown {
  position: absolute;
  top: 40px;
  right: 0;
  background: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  overflow: hidden;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  z-index: 1000;
}

.user-dropdown .dropdown-item {
  display: flex;
  align-items: center;
  padding: 8px 12px;
  background: none;
  border: none;
  text-align: left;
  font-weight: 500;
  color: #333;
  transition: background 0.2s;
}

.user-dropdown .dropdown-item:hover {
  background: #ffe5e5;
}

.user-dropdown .logout {
  color: #b71c1c;
  font-weight: 600;
}

/* Fade animation */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter-from, .fade-leave-to {
  opacity: 0;
}

.modal-body p {
  word-break: break-word;
  overflow-wrap: anywhere;
}


/* Make header stack on small screens */
@media (max-width: 576px) {
  .header-bar {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .user-header {
    width: 100%;
    justify-content: flex-start;
    margin-top: 8px;
  }

  .user-info span {
    font-size: 13px;
    word-break: break-word;
  }

  .user-dropdown {
    right: auto;
    left: 0;
  }
  
}

@media (max-width: 576px) {
  .modal-header {
    padding: 1rem !important;
  }
  .modal-body {
    padding: 1rem !important;
  }
}
</style>